"use client";
import { jsx } from "react/jsx-runtime";
import IconButton from "../../buttons/IconButton/IconButton.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { Transition } from "@mantine/core";
import { useWindowScroll } from "@mantine/hooks";
import { forwardRef } from "react";
import Floater from "../Floater/Floater.js";
import '../../../assets/ScrollToTop.css';const root = "_root_s2vux_2";
const ScrollToTopStyles = {
  root
};
const _ScrollToTop = forwardRef((props, ref) => {
  const { position = { bottom: 20, right: 20 }, className, ...rest } = props;
  const [scroll, scrollTo] = useWindowScroll();
  const handleClick = () => {
    scrollTo({ y: 0 });
  };
  return /* @__PURE__ */ jsx(Floater, { ...rest, position, ref, children: /* @__PURE__ */ jsx(Transition, { transition: "slide-up", mounted: scroll.y > 0, children: (transitionStyles) => /* @__PURE__ */ jsx(
    IconButton,
    {
      className: `${ScrollToTopStyles.root} ${className}`,
      icon: "ChevronUp",
      style: { ...transitionStyles },
      onClick: handleClick,
      ariaLabel: "Scroll to top",
      circular: true
    }
  ) }) });
});
_ScrollToTop.displayName = "ScrollToTop";
const ScrollToTop = sharedHandler(_ScrollToTop);
ScrollToTop.displayName = _ScrollToTop.displayName;
export {
  ScrollToTopStyles as S,
  ScrollToTop as default
};
